<template>
    <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light bg-light"  v-if=storedStatusJWT>
            <div className="collapse navbar-collapse">
                <Navbar></Navbar>
            </div>
        </nav>
        <router-view></router-view>
        <Footer></Footer>
    </div>
</template>
<script>
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import {mapGetters} from 'vuex'
    export default {
        components: {Navbar, Footer},
        computed: {
            ...mapGetters([
                'storedStatusJWT'
            ])
        }
    }
</script>
<style>
@media screen {
    .content-page {
        margin-top: 20px;
        margin-left: 20px;
        margin-right: 20px;
    }
}
</style>
